<template>
  <div class="DivCopyData">
    <el-row>
      <el-col :span="12">
        <h1>设备数据拷贝</h1>
        <div
          v-loading="loading"
          class="rowdev"
          :element-loading-text="loadingtext"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
            <el-form-item label="参考设备" prop="oldDevice">
              <el-input v-model="ruleForm.oldDevice" />
            </el-form-item>
            <el-form-item label="修改设备" prop="newDevice">
              <el-input
                v-model="ruleForm.newDevice"
              />
            </el-form-item>
            <el-form-item label="时间范围" required>
              <el-col :span="11">
                <el-form-item prop="date1">
                  <el-date-picker
                    v-model="ruleForm.time1"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="timestamp"
                    placeholder="选择日期"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">
                -
              </el-col>
              <el-col :span="11">
                <el-form-item prop="date2">
                  <el-date-picker
                    v-model="ruleForm.time2"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="timestamp"
                    placeholder="选择时间"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" @click="submitForm('ruleForm')">
                提交
              </el-button>
              <el-button :loading="loading" @click="resetForm('ruleForm')">
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="12">
        <h1>请求结果</h1>
        <div class="mes" v-html="message" />
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { saveData } from '../utils/httpMain.js'
import { relativeTime, relativeTimeH } from '../utils/helpdata.js'
export default {
  name: 'Copydata',
  data() {
    return {
      ruleForm: {
        oldDevice: '',
        newDevice: '',
        time1: '',
        time2: ''
      },
      message: '',
      loading: false,
      loadingtext: '此操作很花时间请不要重新提交请求，耐心等待',
      num: 0,
      rules: {
        oldDevice: [
          { required: true, message: '请输入参考的设备编号', trigger: 'blur' }
        ],
        newDevice: [
          { required: true, message: '请输入修改的设备编号', trigger: 'blur' }
        ],
        time1: [
          { required: true, message: '请输入开始时间', trigger: 'blur' }
        ],
        time2: [
          { required: true, message: '请输入结束时间', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    onSubmit(oldDevice, newDevice, time1) {
      var t1 = relativeTime(new Date(time1).getTime())
      var t2 = relativeTime(new Date(time1).getTime() + 60 * 60 * 1000)
      console.log(t1, t2)
      console.log(relativeTimeH(t1))
      var _this = this
      saveData({ oldDevice, newDevice, time1: t1, time2: t2 }).then(re => {
        console.log(re)
        if (re.data.data.message === '设备编号不存在') {
          _this.message = '设备编号不存在，请重新填写'
          this.loading = false
          return
        }
        _this.message = `返回时间${relativeTime(new Date())} 时间段${relativeTimeH(t1)}-${relativeTimeH(t2)} 请求替换成功<br/>` + _this.message
        if (relativeTime(_this.ruleForm.time2) !== t2) {
          _this.onSubmit(oldDevice, newDevice, t2)
        } else {
          console.log(relativeTime(new Date()))
          _this.loading = false
        }
      }).catch(error => {
        console.log('返回错误重新访问')
        _this.message = `返回时间${relativeTime(new Date())} 时间段${relativeTimeH(t1)}-${relativeTimeH(t2)} 请求失败重新请求<br/>` + _this.message
        _this.onSubmit(oldDevice, newDevice, t1)
        console.log(error)
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm)
          console.log(relativeTime(this.ruleForm.time1))
          console.log(relativeTime(this.ruleForm.time2))
          const t1 = relativeTime(this.ruleForm.time1)
          this.loading = true
          this.message = ''
          console.log(relativeTime(new Date()))
          this.onSubmit(this.ruleForm.oldDevice, this.ruleForm.newDevice, t1)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      var _this = this
      // this.$refs[formName].resetFields()
      setTimeout(function() {
        if (_this.num < 10) {
          console.log(_this.num++)
          _this.resetForm('ss')
        }
      }, 1 * 1000)
    },
    formatTime(date) {
      var year = date.getFullYear()
      var month = date.getMonth() + 1; month = month < 10 ? '0' + month : month
      var day = date.getDate(); day = day < 10 ? '0' + day : day
      return year + '-' + month + '-' + day
    }
  }
}
</script>
<style>
.DivCopyData{
    text-align: center;
}
.rowdev{
    border: cadetblue solid;
    height: 500px;
    margin:20 auto
}
.demo-ruleForm{
  margin-top: 20px;
}
.mes{
  height: 500px;
  overflow-y: auto;
  border:  cadetblue solid
}
</style>
